import style from "./CardOfAspect.module.css";
import {faArrowDown} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const CardOfAspect = (props) => {
    const data = props.data;

    return (
        <div className={style.container}>
            <h4 dangerouslySetInnerHTML={{__html: data.title}}></h4>
            <p dangerouslySetInnerHTML={{__html: data.content}}></p>
            <FontAwesomeIcon icon={faArrowDown} className={style.icon}/>
        </div>
    )
}
export default CardOfAspect;
